<template>
  <div>
    <DxLoadPanel
      :visible="loadingVisible"
      :show-indicator="showIndicator"
      :show-pane="showPane"
      :shading="shading"
      :hide-on-outside-click="hideOnOutsideClick"
      shading-color="rgba(0,0,0,0.4)"
    />
  </div>
</template>
    
<script>
    import { DxLoadPanel } from "devextreme-vue/load-panel";
    export default {
    name: "LoaderComponent",
    components: { DxLoadPanel },
    data() {
        return {
        loadingVisible: true,
        showIndicator: true,
        shading: true,
        showPane: true,
        hideOnOutsideClick: false,
        };
    },
    };
</script>
    
<style scoped>
</style>